import React from 'react';
import { useEffect, useState } from 'react'
import styles from '../../styles/modules/components/SelfServe/enter-address.module.scss';
import { GetCategoryDetails } from '../../api/selfserve';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import UIDropdown from '../common/ui-components/input/UIDropdown/UIDropdown';
import {
    updateCategoryDetails,
} from '../../redux/actions/selfserveActions';
import {addAppRenderParams, generateStaticDates} from '../../utils/selfserve'
import { useRouter } from 'next/router';
interface DeviceDetails {
    category_type?: any;
    category?:any,
    brand?: any;
}

const AddDeviceDetails = (props: any) => {

    const [deviceOptionList, setDeviceOptionList] = useState<any>([])
    const [selectedDevice, setSelectedDevice] = React.useState<any>({ key: '', value: '', text: '' });

    const [brandOptionList, setBrandOptionList] = useState<any>([])
    const [selectedBrand, setSelectedBrand] = React.useState<any>({ key: '', value: '', text: '' });

    const [deviceTypeOptionList, setDeviceTypeOptionList] = useState<any>([])
    const [selectedDeviceType, setSelectedDeviceType] = React.useState<any>({ key: '', value: '', text: '' });

    const { categoryDetails } = props.selfserveReducer
    let categoryBase = categoryDetails[selectedDevice.value]?.category_based
    let device_detail : DeviceDetails = {};
    const router = useRouter()

    useEffect(() => {
        const {
            planDetails:{ homecare_device_list },
            deviceDetails,
            editScreen:{ isEditing }
        } = props.selfserveReducer
        let parent_device_list:string = '';
        if (!homecare_device_list) {
          parent_device_list = props.selfserveReducer.parentPlanDetails.homecare_device_list
        }
        homecare_device_list ? setDeviceOptionList(getOptionsLists(homecare_device_list.split(','))) : setDeviceOptionList(getOptionsLists(parent_device_list.split(',')))
        if(Object.keys(deviceDetails) && !deviceDetails.device_id && isEditing == true){
            const { category_type, brand, category} = deviceDetails
            props.setDeviceDetails(deviceDetails)
            category_type && fetchCategoryData(category_type)
            preselectedData(setSelectedDevice,category_type);
            preselectedData(setSelectedBrand,brand);
            category && preselectedData(setSelectedDeviceType,category);
            props.setDisableBtn(false)
            dispatch({
                type: "ADD_SR_SLOT_SELECTION_DATA",
                data: {slots: generateStaticDates(30), isDateAvailable: true, items: [{category_type: ''}]},
              })

        }
    }, [])
    const preselectedData = (selection,value) =>{
        selection({ key: value, value: value, text: value })
    }
    const fetchCategoryData = (category_type)=>{

        if(!categoryDetails[category_type]){
            const data = {
                category_types:[category_type],
            }
            GetCategoryDetails({
                "application": "website",
                "data": JSON.stringify(data),
                plan_type:props.selfserveReducer.parentPlanDetails.plan_name

            }).then((res: any) => {
                const response = res.data;
                const brandList = response[category_type].brands
                const subCategoriesList = response[category_type].sub_categories
                setBrandOptionList(getOptionsLists(brandList))
                setDeviceTypeOptionList(getOptionsLists(subCategoriesList))
                dispatch(updateCategoryDetails(response))
            }).catch(() => {
                addAppRenderParams(router)
            })
        }else{
            const brandList = categoryDetails[category_type].brands
            const subCategoriesList = categoryDetails[category_type].sub_categories
            setBrandOptionList(getOptionsLists(brandList))
            setDeviceTypeOptionList(getOptionsLists(subCategoriesList))
        }
    }

    const handleSelectedDevice = (value) => {
        setSelectedDevice(value)
        let category_type = value.value
        fetchCategoryData(category_type)
        eraseDependedFields("Device");
        props.setDisableBtn(true);
    }
    const eraseDependedFields = (type) => {
        switch(type){
            case "Device":
                setSelectedBrand(({ key: '', value: '', text: '' }))
                setSelectedDeviceType(({ key: '', value: '', text: '' }))
            default:
                setSelectedBrand(({ key: '', value: '', text: '' }))
                setSelectedDeviceType(({ key: '', value: '', text: '' }))

        }
    }
    const handleSelectedBrand = (value) => {
        setSelectedBrand(value)
        device_detail["category_type"] =  selectedDevice.value
        device_detail["brand"] = value.value
        props.setDeviceDetails(device_detail)
        if(!categoryBase) props.setDisableBtn(false);
    }
    const handleSelectedType = (value) => {
        setSelectedDeviceType(value)
        device_detail["category_type"] =  selectedDevice.value
        device_detail["brand"] = selectedBrand.value
        device_detail["category"] =  value.value
        props.setDeviceDetails(device_detail)
        props.setDisableBtn(false)
    }
    const dispatch:any = useDispatch()

    const sortOptionList = (a, b) => {
      if (a.value < b.value) return -1;
      if (a.value > b.value) return 1;
      return 0;
    }

    const getOptionsLists = (options)=>{
        let OptionLists: Record<string,string>[] = [];
        for(let option of options){
            OptionLists.push({"key":option.trim(),"value":option.trim(),"text":option.trim()})
          }
        return OptionLists;
    }


    return (
        <div>
            <div className={styles.input_two} style={{'marginBottom': '15px'}}>
                <UIDropdown
                    className={''}
                    propsError={''}
                    label={"Device"}
                    options={deviceOptionList.sort(sortOptionList)}
                    selected_option={selectedDevice}
                    placeholder={'Select Device'}
                    onChange={(value) => { handleSelectedDevice(value) }}

                >
                </UIDropdown>
            </div>

            {selectedDevice.value &&
                <div className={styles.input_two} style={{'marginBottom': '15px'}}>
                    <UIDropdown
                        className={''}
                        propsError={''}
                        label={"Brand"}
                        options={brandOptionList.sort(sortOptionList)}
                        selected_option={selectedBrand}
                        placeholder={'Select Brand'}
                        onChange={(value) => { handleSelectedBrand(value) }}
                    >
                    </UIDropdown>
                </div>
            }
            {selectedBrand.value && categoryBase &&
            <div className={styles.input_two} style={{'marginBottom': '15px'}}>
                <UIDropdown
                    className={''}
                    propsError={''}
                    label={"Type"}
                    options={deviceTypeOptionList}
                    selected_option={selectedDeviceType}
                    placeholder="Select Type"
                    onChange={(value) => { handleSelectedType(value) }}

                >
                </UIDropdown>
            </div>
            }
        </div>
    )
}

const mapStateToProps = (state: any) => {
    return {
        selfserveReducer: state.selfserveReducer,
    }
}

export default connect(mapStateToProps)(AddDeviceDetails);
